import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAccountSubcategory } from "src/models/Stores/AccountSubcategory.models";

interface AccountSubcategoryState {
  accountSubcategories: IAccountSubcategory[];
  accountSubcategoryToEdit: IAccountSubcategory | null;
}

const initialState: AccountSubcategoryState = {
  accountSubcategories: [],
  accountSubcategoryToEdit: null,
};

const accountSubcategorySlice = createSlice({
  name: "AccountSubcategory",
  initialState,
  reducers: {
    setAccountSubcategoryList: (
      state,
      action: PayloadAction<IAccountSubcategory[]>
    ) => {
      state.accountSubcategories = action.payload;
    },
    concatListAccountSubcategory: (
      state: AccountSubcategoryState,
      action: PayloadAction<IAccountSubcategory[]>
    ) => {
      state.accountSubcategories = [
        ...state.accountSubcategories.concat(action.payload),
      ];
    },
    setAccountSubcategoryToEdit: (
      state,
      action: PayloadAction<IAccountSubcategory | null>
    ) => {
      state.accountSubcategoryToEdit = action.payload;
    },
    addAccountSubcategory: (
      state,
      action: PayloadAction<IAccountSubcategory>
    ) => {
      state.accountSubcategories.push(action.payload);
    },
    updateAccountSubcategory: (
      state,
      action: PayloadAction<IAccountSubcategory>
    ) => {
      let itemIndex = state.accountSubcategories.findIndex(
        item =>
          item.accountSubcategoryId === action.payload.accountSubcategoryId
      );
      if (itemIndex !== -1)
        state.accountSubcategories[itemIndex] = action.payload;
    },
    deleteAccountSubcategory: (state, action: PayloadAction<number>) => {
      const newArray = state.accountSubcategories.filter(
        item => item.accountSubcategoryId !== action.payload
      );
      state.accountSubcategories = newArray;
    },
  },
});

export const {
  setAccountSubcategoryList,
  concatListAccountSubcategory,
  setAccountSubcategoryToEdit,
  addAccountSubcategory,
  updateAccountSubcategory,
  deleteAccountSubcategory,
} = accountSubcategorySlice.actions;

export default accountSubcategorySlice.reducer;
